import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { ChevronDown } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context';

export default function HeaderButtons() {
  const { definitions: { entityNameModule, entityNamePlural, entityName, basePath } } = useGrid()

  const path = useMemo(() => {
    if (basePath) return basePath
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNamePlural, entityNameModule])

  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button size='lg' color='accent' className='flex items-center'>
        Add {entityName}
        <ChevronDown size={12} />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      <DropdownItems path={path} />
    </DropdownMenuContent>
  </DropdownMenu>
}

function DropdownItems({ path }) {
  const { store: { collections: { items } } } = useGrid()

  const disabled = useMemo(() => items.reduce((disabled, item) => {
    disabled[item.typeTemplate] = true
    return disabled
  }, {}), [items])

  return <>
    {TEMPLATES.map(template => {
      const { label, type } = template
      const isDisabled = disabled[type]

      if (isDisabled) {
        return <DropdownMenuItem key={type} disabled={true}>
          <span>{label}</span>
        </DropdownMenuItem>
      }

      return <Link key={type} to={`${path}/add/${type}`}>
        <DropdownMenuItem>
          {label}
        </DropdownMenuItem>
      </Link>
    })}
  </>
}

const TEMPLATES = [
  { type: 'password_reset', label: 'Password Reset' },
  { type: 'consumer_delete_report', label: 'Consumer Delete Report' },
  { type: 'sweep_new_winner', label: 'Sweep New Winner Alert' },
  // { type: 'sweep_subscription_confirmation', label: 'Sweep Subscription Confirmation' },
]
